import {Component, Inject, inject, ChangeDetectionStrategy} from '@angular/core';
import {ModalData} from "../../types/modal-data.type";
import {IconComponent} from "../icon/icon.component";
import {ButtonComponent} from "../button/button.component";
import {ModalRef} from "../../services/modal.service";

@Component({
    selector: 'app-error-modal',
    imports: [
        IconComponent,
        ButtonComponent,
    ],
    templateUrl: './error-modal.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './error-modal.component.scss'
})
export class ErrorModalComponent {
  readonly modalRef: ModalRef<ErrorModalComponent> = inject<ModalRef<ErrorModalComponent>>(ModalRef);

  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(@Inject(ModalData) public errorInfo: { title: string, description: string }) {}
}
